import { styled } from "@mui/system";
import { normalScrollHeight } from "../../constants";
export const transitionDuration = 400;

export const StyledVerticalPaginationWrapper = styled("div")(
  ({ theme, isMobileNotificationActive }) => ({
    position: "relative",
    "& .childWrapper": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      position: "relative",
      boxSizing: "border-box",
      minHeight: 1,
      padding: "15px 0",
      "&:last-of-type": {
        marginBottom: 0
      },
      [theme.breakpoints.up("sm")]: {
        minHeight: "100vh",
        // this is for IE11 height should be less than min-height to work
        height: "1px"
      },
      [theme.breakpoints.between("xl", "lg")]: {
        padding: "18vh 20px"
      },
      [theme.breakpoints.only("xs")]: {
        height: "auto"
      },
      [`${theme.breakpoints.only("xs")}, (max-height: ${normalScrollHeight}px)`]: {
        marginBottom: 40,
        height: "auto"
      },
      "&.videoWrapper": {
        [theme.breakpoints.only("xs")]: {
          height: isMobileNotificationActive ? 444 : 380,
          marginBottom: 40
        }
      }
    }
  })
);

export const StyledVerticalPaginationDots = styled("div")(({ theme }) => ({
  position: "fixed",
  top: "50vh",
  right: "30px",
  width: "10px",
  zIndex: 2,
  transform: "translateY(-50%)",
  [theme.breakpoints.only("sm")]: {
    right: 15
  },
  [`${theme.breakpoints.only("xs")}, (max-height: ${normalScrollHeight}px)`]: {
    display: "none"
  },
  "& .paginationDot": {
    width: "10px",
    height: "10px",
    "& + &": {
      marginTop: "15px"
    },
    "&:focus": {
      outline: "none"
    },
    border: 0,
    padding: 0,
    borderRadius: "50%",
    backgroundColor: "rgba(0,0,0, .2)",
    cursor: "pointer",
    "&.current": {
      backgroundColor: "#020f21",
      cursor: "auto"
    }
  }
}));
